module.exports = __webpack_public_path__ + "img/9-consumers-microlines-min-new.png";